import { render, staticRenderFns } from "./classroomComments.vue?vue&type=template&id=1668d658&scoped=true"
import script from "./classroomComments.vue?vue&type=script&lang=js"
export * from "./classroomComments.vue?vue&type=script&lang=js"
import style0 from "./classroomComments.vue?vue&type=style&index=0&id=1668d658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668d658",
  null
  
)

export default component.exports